import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'membership_page';
export const route = 'membership_page/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "membership_page" */
/* webpackPrefetch: true */
'../components/MembershipPage')));